{
  "version": 1,
  "asset_id": "56d4b8c9-245f-48e9-856a-0d3f7e54b5b9",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/56d4b8c9-245f-48e9-856a-0d3f7e54b5b9/sleeve-ugi-reflux-pre-899-es.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/56d4b8c9-245f-48e9-856a-0d3f7e54b5b9/sleeve-ugi-reflux-pre-899-es.jpg",
  "original_filename": "sleeve-ugi-reflux-pre-899-es.jpg",
  "size": 87259,
  "content_type": "image/jpeg",
  "created_at": "2026-09-28T16:43:58Z"
}
